$ ->
    $('[data-maintenance-id]').each ->
        self = $ @
        modeId = self.attr 'data-maintenance-id'
        closeBtn = self.find '[data-dismiss]'

        closeBtn.on 'click', =>
            Cookies.set('m_' + modeId, 1, { expires: 90 });
            self.slideUp()
